import CreditCardForm from './CreditCardForm';

export default CreditCardForm;
